import { AnimatedList, Toast } from 'drywall';
import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';
var ALIGN = {
  'top-start': 'flex-start',
  'top': 'center',
  'top-end': 'flex-end',
  'bottom-start': 'flex-start',
  'bottom': 'center',
  'bottom-end': 'flex-end'
};

/** @class ToastProviderMixin */
/** @method */
export var ToastProviderMixin = function ToastProviderMixin(props) {
  var placement = props.placement;
  return token({
    zIndex: 'Toast.Provider.zIndex',
    margin: 'Toast.margin',
    animatedListMargin: 'Toast.animatedList.margin',
    animatedListPadding: 'Toast.animatedList.padding'
  }, function (_ref) {
    var zIndex = _ref.zIndex,
      margin = _ref.margin,
      _ref$animatedListMarg = _ref.animatedListMargin,
      animatedListMargin = _ref$animatedListMarg === void 0 ? 0 : _ref$animatedListMarg,
      _ref$animatedListPadd = _ref.animatedListPadding,
      animatedListPadding = _ref$animatedListPadd === void 0 ? 0 : _ref$animatedListPadd;
    return css(["position:fixed;", ":0;right:0;left:0;z-index:", ";pointer-events:none;", "{pointer-events:auto;margin:", ";margin-", ":0;}", "{margin:", "px;padding:", "px;list-style:none;display:flex;flex-direction:column", ";align-items:", ";}", "{position:relative;}"], placement.indexOf('top') === 0 ? 'top' : 'bottom', zIndex, Toast, margin ? margin + "px" : spaceMixin('sm')(props), placement.indexOf('top') === 0 ? 'bottom' : 'top', AnimatedList, animatedListMargin, animatedListPadding, placement.indexOf('top') === 0 ? '-reverse' : '', ALIGN[placement], AnimatedList.Item);
  })(props);
};